import '../scss/module_magazine.scss';

import * as Sentry from "@sentry/browser";

// ---- dont need this import ? ----

// import Collapse from 'bootstrap/js/dist/collapse'
// import Modal from 'bootstrap/js/dist/modal'
// import Dropdown from 'bootstrap/js/dist/dropdown'

import './module_common_actions';

import { initNavbar } from './module_header';
import { setDoNotShowDl } from './module_common';
import { disableLeavingUserModal } from './module_auth_helper';

import {defaultCarouselSetupNew} from './module_swiper';
import { initCardLazyLoad, updateCardLazyLoad } from './module_lazyload';

window.setDoNotShowDl = setDoNotShowDl;

const magazinePost = $('.magazine-post-ref');
const magazinePostsList = $('.container.posts-list.magazine-home');
const magazineMacroPostsList = $('.container.macro-posts-list');
const magazineCategoryPostsList = $('.container.category-posts-list');
const showMore = $('.show-more-button');

const defaultLimit = itemsPerPage;

let mobileCarousel

function isPostPage(){
    if (magazinePost.length) return true
    return false
}

function isMainPage(){
    if(magazinePostsList.length) return true
    return false
}

function isMacroCategoryPage(){
    if(magazineMacroPostsList.length) return true
    return false
}

function isCategoryPage(){
    if(magazineCategoryPostsList.length) return true
    return false
}


function activateNavCategoryItem(){
    if (!postMacroCategory || !postMacroCategory.translation) return
    const macroSlug = postMacroCategory.translation.slug
    const els = $("[data-slug]")
    els.each(function(){
        const el = $(this)
        if (el.data("slug") === macroSlug){
            el.addClass("active")
            mobileCarousel.slideTo(el.data("idx"))
        }
    })
}

function activateNavAllItem(){
    $(".mag-nav-item.all-articles").addClass("active")
}

function showSpinner() {
    $("#spinner-container").addClass("show");
}

function hideSpinner() {
    $("#spinner-container").removeClass("show");
}

function hideSearchMore(requested, previousN){
    const elemNumber = getElemNumber()
    if (!elemNumber) return

    if(elemNumber < (parseInt(previousN) + parseInt(requested))) {
        showMore.hide();
    }
}

function apiSearch(limit, offset, container){
    if(!container.length) return
    limit = limit || defaultLimit;
    offset = offset || 0;
    const data = {
        limit: limit,
        offset: offset
    }
    if (isMacroCategoryPage()){
        data.mcat = [postMacroCategory.id]
    }else if (isCategoryPage()){
        data.cat = [postCategory.id]
    }
    
    showSpinner();
    $.ajax({
        method: "POST",
        url: searchEndPoint,
        data: data,
        dataType: 'json',
        success: function(data){
            container.append(data['html']);
            hideSearchMore(limit, offset);
            updateCardLazyLoad()
        },
        error: function(err){
        }
    }).done(function() {
        hideSpinner();
    });
}

function getCards(){
    const cont = getContainer();
    if (!cont) return;
    return cont.find('.magazinepost-card-container');
}

function getContainer(){
    if (isMainPage()){
        return magazinePostsList
    }else if (isMacroCategoryPage()){
        return magazineMacroPostsList
    }else if (isCategoryPage()){
        return magazineCategoryPostsList
    }
    return
}

function getElemNumber() {
    const elements = getCards();
    if (!elements) return;

    let elemNumber = elements.length
    if (isMainPage() || isMacroCategoryPage()){
        // REMOVE +1 when we use featured from a distinct endpoint
        // we use +1 because the top post is taken from the global search
        elemNumber = elements.length + 1
    }
    return elemNumber
}

function showNextPage(){
    const cont = getContainer();
    if (!cont) return;

    const elemNumber = getElemNumber()
    if (!elemNumber) return
    apiSearch(defaultLimit, elemNumber, cont.children());
}

const extraPostCarouselSetUp = function(){
    const out = "extra-posts-out"
    const container = "extra-posts-swiper-container"
    defaultCarouselSetupNew(container, out, "auto", 4, 4, 6)
}

const mobileNavbarCarouselSetUp = function(){
    const out = "nav-swiper-out"
    const container = "nav-swiper-container"
    mobileCarousel = defaultCarouselSetupNew(container, out, 'auto', 'auto', 1, 1)  
}

function managePostPage() {
    extraPostCarouselSetUp()
}

function manageMacroCategoryPage() {
    mobileNavbarCarouselSetUp()
    activateNavCategoryItem()
    attachShowMore()
}

function manageCategoryPage() {
    mobileNavbarCarouselSetUp()
    activateNavCategoryItem()
    attachShowMore()
}

function manageHomePage() {
    mobileNavbarCarouselSetUp()
    activateNavAllItem()
    attachShowMore()
}

function attachShowMore(){
    const button = document.querySelector("#showmorebtn")
    if (button) {
        button.addEventListener('click', () => {
            showNextPage()
        })
    }
}

function sentryInit(){
    const prot = window.location.protocol
    if (prot !== 'http:' && prot !== 'https:'){
        sentry_dsn_conf = ''
    }
    Sentry.init({
        dsn: sentry_dsn_conf,
        
        release: js_app_version,
        
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
    });
}

$(function() {
    sentryInit()
    disableLeavingUserModal()

    initNavbar()

    initCardLazyLoad()

    if (isPostPage()){
        managePostPage()
    }
    if (isMacroCategoryPage()){
        manageMacroCategoryPage()
    }
    if (isCategoryPage()){
        manageCategoryPage()
    }
    if (isMainPage()){
        manageHomePage()
    }
});